import { Trans } from '@lingui/macro';
import { MenuItem } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { usePleditor, usePreview } from 'shared/domains/documents';
import { PLEDITOR_IMPORT_BUTTON_SELECTOR } from 'shared/domains/documents/components/Preview/Pleditor/styles/toolbar';
export function ImportDocumentMenuItem(props) {
    const { onClick } = props;
    const { pleditorState } = usePleditor();
    const { isFreeText, isPleditorImportExportAvailable } = usePreview();
    const handleFileUpload = () => {
        const element = document.querySelector(PLEDITOR_IMPORT_BUTTON_SELECTOR);
        if (element instanceof HTMLButtonElement) {
            element.click();
        }
        onClick();
    };
    if (!isPleditorImportExportAvailable || !isFreeText) {
        return null;
    }
    return (<MenuItem onClick={handleFileUpload} disabled={pleditorState === 'initializing'}>
      <Falcon icon="file-import"/>
      <Trans comment="Dropdown label for importing document">Import version</Trans>
    </MenuItem>);
}
